import { z } from "zod";
import { ChallengeCard, ChallengeEnrollment, ChallengeMilestoneReached } from "./challenges.js";
export const CompanyAwardRecipient = z.object({
    userId: z.string().uuid(),
    displayName: z.string(),
    initials: z.string(),
    avatarUrl: z.string().nullable(),
    avatarColor: z.string().nullable(),
});
export const CompanyAwardAchievement = z.object({
    awardId: z.string(),
    earnedCount: z.number().int().nonnegative(),
    percentage: z.number().min(0).max(100).nullable(),
    recipients: z.array(CompanyAwardRecipient).max(3),
});
export const GetCompanyAwardStatsResponse = z.object({
    /** All current HealthOS members in the caller's company, including nonparticipants. */
    companyMemberCount: z.number().int().nonnegative(),
    awards: z.array(CompanyAwardAchievement),
});
/** One route's medals: the route, the member's own progress on it, and when they reached each. */
export const RouteAwardCollectionEntry = z.object({
    route: ChallengeCard,
    /** Null when the member has never walked this route. */
    enrollment: ChallengeEnrollment.nullable(),
    milestoneHistory: z.array(ChallengeMilestoneReached),
});
export const GetRouteAwardCollectionResponse = z.object({
    /** The company challenge route, listed first. Null while the company runs none. */
    currentInstanceId: z.string().uuid().nullable(),
    routes: z.array(RouteAwardCollectionEntry),
    /**
     * Company achievement for the medals on routes other than the current one.
     * The current route's figures stay on `GET /awards/stats`.
     */
    companyStats: GetCompanyAwardStatsResponse,
});
//# sourceMappingURL=challenge-awards.js.map